module.exports = __webpack_public_path__ + "img/BKLCOVER.36d3336a.png";